import { ShipmentStatus } from '#/shared/api/generated/shipment/models'

export const LEADS_TAB_KEYS = {
  NEW_LEADS: 'newLeads',
  ARCHIVED: 'archived',
} as const

export type LeadsTabKey = (typeof LEADS_TAB_KEYS)[keyof typeof LEADS_TAB_KEYS]

export const LEADS_DEFAULT_TAB: LeadsTabKey = LEADS_TAB_KEYS.NEW_LEADS

export const LEADS_COUNT_TAB_KEYS: ReadonlySet<string> = new Set<string>([
  LEADS_TAB_KEYS.NEW_LEADS,
])

export const LEADS_STATUS_BY_TAB: Record<LeadsTabKey, ShipmentStatus> = {
  [LEADS_TAB_KEYS.NEW_LEADS]: ShipmentStatus.lead,
  [LEADS_TAB_KEYS.ARCHIVED]: ShipmentStatus.archived,
}

const LEADS_TAB_BY_STATUS: ReadonlyMap<ShipmentStatus, LeadsTabKey> = new Map(
  (
    Object.entries(LEADS_STATUS_BY_TAB) as Array<[LeadsTabKey, ShipmentStatus]>
  ).map(([tab, status]) => [status, tab]),
)

/** Which tab a shipment with this status lives under; `undefined` when none does. */
export function leadsTabForStatus(
  status: ShipmentStatus | null | undefined,
): LeadsTabKey | undefined {
  return status == null ? undefined : LEADS_TAB_BY_STATUS.get(status)
}

function isLeadsTabKey(value: string | undefined): value is LeadsTabKey {
  return value != null && value in LEADS_STATUS_BY_TAB
}

export function leadsStatusForTab(tab: string | undefined): ShipmentStatus {
  const key = isLeadsTabKey(tab) ? tab : LEADS_DEFAULT_TAB
  return LEADS_STATUS_BY_TAB[key]
}
